import { observer } from "mobx-react-lite";
import React, { Fragment, useContext } from "react";
import { Pagination, Segment, Table } from "semantic-ui-react";
import { RootStoreContext } from "../../app/stores/rootStore";
import ExamListItem from "./ExamListItem";

const ExamList: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { examsByName, page, totalPages, setPage, loadExams } = rootStore.examStore;

  const onPageChange = (e: any, pageInfo: any) => {
    setPage(pageInfo.activePage);
    loadExams();
  };

  return (
    <Fragment>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={8}>Nome</Table.HeaderCell>
            <Table.HeaderCell width={2}>Questões</Table.HeaderCell>
            <Table.HeaderCell width={2}>Duração</Table.HeaderCell>
            <Table.HeaderCell width={2}>Liberado</Table.HeaderCell>
            <Table.HeaderCell width={2}>Banca</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {examsByName.map((exam) => (
            <ExamListItem key={exam.id} exam={exam} />
          ))}
        </Table.Body>

        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan="5">
              <Segment basic clearing floated="right">
                <Pagination
                  defaultActivePage={page}
                  onPageChange={(e, pageInfo) => onPageChange(e, pageInfo)}
                  totalPages={totalPages}
                />
              </Segment>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </Fragment>
  );
};

export default observer(ExamList);
